import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-condiciones-subasta',
  templateUrl: './condiciones-subasta.component.html',
  styleUrls: ['./condiciones-subasta.component.css']
})
export class CondicionesSubastaComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
